import React from "react";
import {
  Box,
  TextField,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  IconButton,
  InputLabel,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const CodeSnippetList = ({
  snippets = [], // Default to empty array if undefined
  onDeleteSnippet,
  onSnippetChange,
  programmingLanguages,
}) => {
  return (
    <Box>
      {snippets.length > 0 ? (
        snippets.map((snippet, index) => (
          <Box
            key={index}
            sx={{
              mb: 2,
              p: 1,
              border: "1px solid #ccc",
              borderRadius: 2,
            }}
          >
            <TextField
              fullWidth
              label="Code Snippet"
              value={snippet.codeSnippet || ""}
              onChange={(e) =>
                onSnippetChange(index, "codeSnippet", e.target.value)
              }
              multiline
              rows={10}
              required
              sx={{ fontFamily: "monospace" }}
            />
            <TextField
              label="Description"
              value={snippet.description || ""}
              onChange={(e) =>
                onSnippetChange(index, "description", e.target.value)
              }
              multiline
              rows={2}
              sx={{ mt: 2, width: "100%" }}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <FormControl sx={{ mt: 2, minWidth: "300px" }} required>
                  <InputLabel>Programming Language</InputLabel>
                  <Select
                    name="programmingLanguage"
                    value={snippet.programmingLanguage}
                    onChange={(e) =>
                      onSnippetChange(
                        index,
                        "programmingLanguage",
                        e.target.value
                      )
                    }
                    label="programmingLanguage"
                    renderValue={(value) =>
                      (value &&
                        programmingLanguages.find((p) => p.key === value)
                          ?.value) ||
                      value
                    }
                  >
                    {programmingLanguages.map((lang) => (
                      <MenuItem key={lang.key} value={lang.key}>
                        {lang.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={snippet.active || false}
                      onChange={(e) =>
                        onSnippetChange(index, "active", e.target.checked)
                      }
                    />
                  }
                  label="Active"
                />
              </Box>
              <IconButton color="error" onClick={() => onDeleteSnippet(index)}>
                <DeleteIcon />
              </IconButton>
            </Box>
          </Box>
        ))
      ) : (
        <Typography variant="body2" color="text.secondary">
          No code snippets available.
        </Typography>
      )}
    </Box>
  );
};

export default CodeSnippetList;
